import React, { PureComponent } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// module
import { FixedSizeList as List } from 'react-window';
import { AutoSizer } from 'react-virtualized';

// ui/ux
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// ours
import Waiting from '../Waiting';
import { uniqueId, convertSnakeCase } from '../../common';

const styles = (/* theme */) => ({
  cover: {
    objectFit: 'cover',
    cursor: 'pointer'
  },
  fill: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    position: 'absolute',
    zIndex: 1,
    cursor: 'pointer'
  }
});

class PhotoChart extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      id: uniqueId(),
      idx: -1
    };

    this.onPhotoClicked = this.onPhotoClicked.bind(this);
  }
  onPhotoClicked(idx) {
    const { data } = this.props;
    if (this.props.onPhotoClicked) {
      this.props.onPhotoClicked(data[idx]);
    } else {
      this.setState({ idx });
    }
  }
  renderOverlay() {
    const { classes, data } = this.props;
    const { idx } = this.state;
    if (idx === -1 || !data) return null;

    return <img className={classes.fill} src={data[idx]} onClick={() => this.onPhotoClicked(-1)} />;
  }
  render() {
    const { classes, data, width, title } = this.props;
    const { idx } = this.state;

    const boxStyle = {
      height: width,
      width: width,
      position: 'relative'
    };

    if (!data) {
      return (
        <Box style={boxStyle}>
          <Typography variant="h6" gutterBottom>
            {convertSnakeCase(title)}
          </Typography>
          <Waiting />
        </Box>
      );
    }

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          {convertSnakeCase(title)}
        </Typography>

        <Box style={boxStyle}>
          {this.renderOverlay()}
          <RenderAutoSizer idx={idx} width={width} data={data} classes={classes} onPhotoClicked={this.onPhotoClicked} />
        </Box>
      </React.Fragment>
    );
  }
}

// move this heavy component out
// eslint-disable-next-line react/display-name
const RenderAutoSizer = React.memo((props) => {
  const { classes, idx, data, width, onPhotoClicked } = props;
  const itemSize = data.length > 2 ? width / 2.5 : data.length > 1 ? width / 2.0 : width;
  return (
    <AutoSizer style={{ display: idx > -1 ? 'none' : null }}>
      {({ width, height }) => (
        <List height={height} width={width} layout="horizontal" itemCount={data.length} itemSize={itemSize}>
          {({ index, style }) => <img className={classes.cover} src={data[index]} style={style} onClick={() => onPhotoClicked(index)} />}
        </List>
      )}
    </AutoSizer>
  );
});

RenderAutoSizer.propTypes = {
  classes: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  onPhotoClicked: PropTypes.func.isRequired
};

PhotoChart.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  data: PropTypes.array,
  title: PropTypes.string,

  width: PropTypes.number,

  onPhotoClicked: PropTypes.func
};

PhotoChart.defaultProps = {
  width: 400
};

export default withTheme(withStyles(styles)(PhotoChart));
